export default __webpack_public_path__ + "static/media/skype.1f165620.png";